import { hasSession, removeToken } from "./auth";
import { isApiBaseReady } from "./bootstrap";

/** 未登录可访问的路由（仅首页 + 登录注册 + 启动页） */
export const ROUTE_WHITE_LIST = ["/", "/login", "/register", "/splash"];

/** 未登录可调用的接口，失败时不强制跳转登录 */
export const PUBLIC_API_WHITELIST = [
  "login_pc",
  "register",
  "app",
  "bannerList",
  "gametype",
  "platlist",
  "webnotice",
  "activitytype",
  "activitylist",
  "tqactivitytype",
  "article",
];

let redirecting = false;

export function isLoggedIn() {
  return hasSession();
}

export function isWhiteRoute(path) {
  if (!path) return false;
  const normalized = path.split("?")[0].split("#")[0];
  return ROUTE_WHITE_LIST.includes(normalized);
}

export function isPublicApi(url = "") {
  if (!url) return false;
  const path = String(url).split("?")[0].replace(/^\//, "");
  return PUBLIC_API_WHITELIST.some(
    (item) => path === item || path.endsWith(`/${item}`),
  );
}

/**
 * 统一跳转登录页，防止并发请求/多次点击重复跳转
 */
export function redirectToLogin(router, options = {}) {
  const { saveRedirect = true, clearToken = false } = options;

  if (!router || redirecting || !isApiBaseReady()) return false;

  const { path, fullPath } = router.currentRoute;
  if (path === "/login" || path === "/register") return false;

  redirecting = true;

  if (clearToken) {
    removeToken();
  }

  const query =
    saveRedirect && fullPath && fullPath !== "/"
      ? { redirect: fullPath }
      : {};

  router
    .replace({ path: "/login", query })
    .catch(() => {})
    .finally(() => {
      setTimeout(() => {
        redirecting = false;
      }, 400);
    });

  return true;
}

export function handleAuthError(router, config, options = {}) {
  const { clearToken = true } = options;
  if (isPublicApi(config?.url)) return false;
  if (clearToken) removeToken();
  return redirectToLogin(router, { saveRedirect: true, clearToken: false });
}
